/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.30",
    versionName: "0.2.0-nightly.2025.7.30",
    versionChannel: "nightly",
    buildDate: "2025-07-30T00:08:27.139Z",
    commitHash: "e3217e8d5a8bbc801509a9892eb9ab2f40abe9a0",
};
